import { FC } from 'react';

import CommonButton from 'components/CommonButton/CommonButton';
import { renderToast } from 'components/Toast/Toast';

const BASE_URL = process.env.REACT_APP_BACK_END_URL ?? '';

const ENDPOINTS = [
  {
    title: 'Metrics',
    description:
      'Online Scheduling Report totals: requested, accepted, shows, new and existing patients, rejected and production, plus the Traffic by Source and Service Performance breakdowns.',
    url: `${BASE_URL}/reporting/metrics?startDate=2026-09-01&endDate=2026-09-30`,
  },
  {
    title: 'Appointments',
    description:
      'Requested appointments, newest first, with date/time, practitioner, service, requested time, source and production. Patient name and phone number are masked. Paginated with page and limit (max 100).',
    url: `${BASE_URL}/reporting/appointments?startDate=2026-09-01&endDate=2026-09-30&page=1&limit=50`,
  },
];

const buildCurlCommand = (url: string) =>
  `curl -H "X-API-Key: <your API key>" "${url}"`;

const ApiUsage: FC = () => {
  const handleCopy = async (content: string) => {
    await navigator.clipboard.writeText(content);
    renderToast({ message: 'Copied successfully', type: 'success' });
  };

  return (
    <div className="mt-3">
      <h4 className="text-16 leading-[2.4rem] font-bold">How to Use</h4>
      <p className="text-dim-grey">
        Send the key in the X-API-Key header. Dates use the YYYY-MM-DD format
        and cover whole days in UTC, filtered by when the appointment was
        requested, the same as the Online Scheduling Report. A range can cover
        up to 360 days, and each key can make up to 60 requests per minute.
      </p>
      <div className="flex flex-col gap-y-2.4 mt-2.4">
        {ENDPOINTS.map(({ title, description, url }) => (
          <div
            key={title}
            className="bg-white shadow-primary rounded-[1rem] px-3 py-2.4"
          >
            <div className="flex justify-between items-center gap-x-1.6">
              <div>
                <h5 className="font-bold">{title}</h5>
                <p className="text-dim-grey">{description}</p>
              </div>
              <CommonButton
                variant="secondary"
                className="!min-h-[3.2rem] shrink-0"
                onClick={() => handleCopy(buildCurlCommand(url))}
              >
                Copy Example
              </CommonButton>
            </div>
            <pre className="mt-1.6 whitespace-pre-wrap break-all">
              <code>{buildCurlCommand(url)}</code>
            </pre>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApiUsage;
